if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.init();

        this.addEventListener('click', (event) => {
          if (event.target.hasAttribute('data-media-id')) {
            if (event.target.hasAttribute('data-zoomed')) {
              this.resetZoom(event.target);
              return;
            }

            event.target.setAttribute('data-zoomed', true);
            const x = event.clientX;

            const y = event.clientY;

            const xDelta = (x - event.target.clientWidth / 2) * -1;
            const yDelta = (y - event.target.clientHeight / 2) * -1;

            event.target.style.transform = `translate3d(${xDelta}px, ${yDelta}px, 0) scale(2)`;
          }
        });
      }

      resetZoom(image) {
        image.removeAttribute('data-zoomed');
        image.style.transform = `translate3d(0px, 0px, 0) scale(1)`;
      }

      init() {
        this.elements = {
          viewer: this.querySelector('[id^="GalleryModalViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryModalThumbnails"]'),
        };

        this.elements.viewer.addEventListener('slideChanged', this.onSlideChanged.bind(this));

        this.initThumbnails();
      }

      initThumbnails() {
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });

        this.elements.viewer.resetPages();
      }

      setActiveMedia(mediaId) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }

        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
        this.querySelectorAll('[data-media-id]').forEach((img) => {
          this.resetZoom(img);
        });
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      hide() {
        super.hide();
        removeTrapFocus();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        trapFocus(this);
      }

      showActiveMedia() {
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        activeMedia.scrollIntoView();
      }
    }
  );
}
